$.rails.allowAction = function (link) {
  if (link.data("confirm") == undefined) {
    return true;
  }
  $.rails.showConfirmationDialog(link);
  return false;
}

$.rails.confirmed = function (link) {
  link.data("confirm", null);
  link.trigger("click.rails");
}

$.rails.showConfirmationDialog = function (link) {
  var message = link.data("confirm"),
    title = "",
    confirmLabel = "Confirmer",
    cancelLabel = "Annuler";

  if (typeof (link.data("confirm")) == 'object') {
    if (link.data("confirm").title) {
      title = link.data("confirm").title;
    }

    if (link.data("confirm").message) {
      message = link.data("confirm").message;
    }

    if (link.data("confirm").confirm_label) {
      confirmLabel = link.data("confirm").confirm_label;
    }

    if (link.data("confirm").cancel_label) {
      cancelLabel = link.data("confirm").cancel_label;
    }
  }

  var modalOptions = {
    title: title,
    message: message,
    buttons: {
      confirm: {
        label: confirmLabel,
        className: "btn btn-primary float-right mr-10",
      },
      cancel: {
        label: cancelLabel,
        className: "btn btn-default float-right",
      }
    },
    callback: function (result) {
      if (result) {
        $.rails.confirmed(link);
      }
      this.hide();
    }
  }

  bootbox.confirm(modalOptions);
}